import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { getNextStep, getVisibleWizardFieldOrder, WIZARD_NUM } from '../helper';

const BusinessCompliance = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    isForEDD,
    handleChange, 
    applicationForm,
    editMode,
    handlePrev,
    setData,
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
        });

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                if (fieldError) {
                    showError(fieldError);
                    return false;
                }
            }
        }
        
        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStep(wizard, applicationForm, data, editMode) });
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            updatedErrors[field] = errorMsg;
            return updatedErrors;
        });
    };

    return (
        <div className="row">
            <div className="col-12">
                
                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["crypto"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('crypto', errorMsg)}
                    isForEDD={isForEDD}
                />

                <div className="mt-4">
                    <h3 style={{ fontWeight: 'bolder' }} className='pt-2 mb-3'>
                        What is a Money Services Business?
                    </h3>
                    <p>
                        A Money Services Business (MSB) refers to a type of financial service provider that offers various services related to money transfers, currency exchange, and payment processing.
                    </p>
                    <p className='pt-1'>
                        For the purposes of this application, FV Bank considers all of the following to be Money Services Businesses, whether a license is required or not in your jurisdictions. (Exchanges, OTC Providers, Liquidity Providers, Wallet Providers, Non-Bank Financial Institutions, VASPS, DLT's EMI's, PSD license holders, Brokers, Remittance Providers, and FX Providers.)
                    </p>
                </div>

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Money_Services_Business"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Money_Services_Business', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["primaryBusinessModel"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('primaryBusinessModel', errorMsg)}
                    isForEDD={isForEDD}
                />

                <div className="mt-4">
                    <h3 style={{ fontWeight: 'bolder' }} className='pt-2 mb-3'>
                        What is a Merchant Acquirer and PSP?
                    </h3>
                    <p>
                        A Merchant Acquirer is a financial institution or payment processor that facilitates the processing of credit or debit card transactions for a merchant. A Payment Service Provider (PSP) allows merchants to accept a wide variety of online payments, including credit cards, digital wallets, and bank transfers.
                    </p>
                </div>

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Merchant_Acquirer_PSP"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Merchant_Acquirer_PSP', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Regulated_Disclosure"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Regulated_Disclosure', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["Regulatory_Agency"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('Regulatory_Agency', errorMsg)}
                    isForEDD={isForEDD}
                />

                <div className='mt-4'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={WIZARD_NUM.BusinessCompliance}
                        showPageNum={false}
                        pageNum={WIZARD_NUM.BusinessCompliance}
                        hideSubmitButton={hideButtons}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default observer(BusinessCompliance);
